// src/pages/DiscountsPage.js
import React, { useEffect, useState } from 'react';
import apiClient from '../api/apiClient';
import { Ticket, Loader2, Copy, Clock, Tag, Gift } from 'lucide-react';

const DiscountsPage = () => {
  const [discounts, setDiscounts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDiscounts = async () => {
      try {
        const res = await apiClient.get('/purchases/discount-codes/');
        setDiscounts(res.data || []);
      } catch (err) {
        console.error('Error fetching discount codes:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchDiscounts();
  }, []);

  const handleCopyCode = (code) => {
    navigator.clipboard.writeText(code).then(() => {
      alert('کد تخفیف کپی شد. هنگام خرید از آن استفاده کنید.');
    }).catch(() => {
      alert('کد تخفیف: ' + code);
    });
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <Loader2 className="animate-spin text-purple-700" size={32} />
      </div>
    );
  }

  return (
    <div className="p-4 max-w-lg mx-auto rtl">
      {/* هدر شیک */}
      <div className="bg-white text-gray-700 border-gray-700 p-4">
        <div className="flex items-center gap-3 mb-3">
          <h1 className="text-[14px] font-extrabold">هدیه فرزانه به شما</h1>
        </div>
      </div>

      {discounts.length === 0 ? (
        <div className="text-center text-gray-500 py-10 bg-white rounded-xl shadow">
          <Ticket size={40} className="mx-auto mb-3 text-gray-300" />
          <p>در حال حاضر کد تخفیفی موجود نیست.</p>
          <p className="text-xs mt-1">به‌زودی هدایای ویژه‌ای برای شما در نظر خواهیم گرفت.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {discounts.map((discount) => (
            <div key={discount.code} className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
              {/* نوار رنگی بالای کارت */}
              <div className={`h-2 ${discount.is_percentage ? 'bg-purple-600' : 'bg-green-600'}`} />
              <div className="p-5">
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <Tag size={18} className="text-purple-600" />
                      <span className="text-[12px] font-bold text-gray-800">{discount.code}</span>
                    </div>
                    <p className="text-[11px] text-gray-500">
                      {discount.is_percentage ? `${discount.value}٪ تخفیف` : `${Number(discount.value).toLocaleString()} تومان تخفیف`}
                    </p>
                  </div>
                  <button
                    onClick={() => handleCopyCode(discount.code)}
                    className="flex items-center gap-1 bg-purple-100 text-purple-700 px-3 py-1.5 rounded-lg text-[11px] font-medium hover:bg-purple-200 transition"
                  >
                    <Copy size={16} />
                    کپی کد
                  </button>
                </div>
                <div className="flex items-center gap-2 text-xs text-gray-400">
                  <Clock size={14} />
                  <span>اعتبار تا {new Date(discount.expiry_date).toLocaleDateString('fa-IR')}</span>
                </div>
                {discount.max_uses > 0 && (
                  <p className="text-xs text-gray-400 mt-1">
                    {discount.max_uses - discount.used_count} استفاده باقی‌مانده از {discount.max_uses}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* نکتهٔ راهنما */}
      <div className="mt-6 bg-yellow-50 border border-yellow-200 rounded-xl p-4 text-[11px] text-yellow-800">
        <p className="font-semibold mb-1">💡 نحوه استفاده</p>
        <p>کد تخفیف را کپی کنید و هنگام خرید محصول، در قسمت «کد تخفیف» جای‌گذاری نمایید. تخفیف به‌طور خودکار اعمال خواهد شد.</p>
      </div>
    </div>
  );
};

export default DiscountsPage;